import { IAlertStatus } from "../common";

export const alertConstants: IAlertStatus = {
  SUCCESS: "ALERT_SUCCESS",
  ERROR: "ALERT_ERROR",
  CLEAR: "ALERT_CLEAR"
};